<script setup>
import { readSingleton } from '@directus/sdk';

const { cms } = useCms();
const { data: agenda } = await useAsyncData('agenda', async () => {
  const data = await cms.request(readSingleton('cmla_2024_conference_agenda'));
  return data.agenda || [];
});
</script>

<template>
  <section class="agenda">
    <a id="conference-agenda" />
    <div class="container">
      <CtaButton tag="div" class="header">Program</CtaButton>
      <div
        class="session row gx-3"
        :class="{ break: item.break }"
        v-for="item in agenda"
        :key="item.time"
      >
        <div class="col-xs-12 col-sm-4">
          <div class="session-time">{{ item.time }}</div>
        </div>
        <div class="col-xs-12 col-sm-8">
          <div class="session-content">
            <div class="session-title" v-if="item.title">{{ item.title }}</div>
            <div class="session-description" v-if="item.description">
              {{ item.description }}
            </div>
            <template v-if="item.speakers">
              <div
                class="speaker"
                v-for="speaker in item.speakers"
                :key="speaker.name"
              >
                <div class="speaker-name">{{ speaker.name }}</div>
                <div class="speaker-qualifications">
                  {{ speaker.qualifications }}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
@import '@/assets/css/variables.scss';
@import 'bootstrap/scss/functions.scss';
@import 'bootstrap/scss/variables.scss';
@import 'bootstrap/scss/mixins.scss';

section {
  padding: 100px 0;
  font-size: 18px;
  font-weight: 400;
  background-color: #f6f6f6;
  --bs-body-bg: #f6f6f6;
}

.agenda {
  .header {
    text-transform: uppercase;
    display: block;
    font-weight: 700;
    font-size: 35px;
    padding: 0.3em 1.5em;
    margin: 0 0 1em 0;
  }

  .session {
    padding: 40px 0;

    + .session {
      border-top: 1px solid #adadad;
    }

    &-time {
      font-size: 20px;
      text-align: center;
      background-color: white;
      border-radius: 10px;
      padding: 17px;
      margin-bottom: 1em;

      @include media-breakpoint-down(lg) {
        padding: 0.7em;
      }
    }

    &-content {
      margin-left: 50px;

      @include media-breakpoint-down(lg) {
        margin-left: 10px;
      }
    }

    &-title {
      color: $primary;
      font-size: 30px;
      font-weight: 600;
      padding: 10px 0;
      white-space: pre-wrap;

      @include media-breakpoint-down(lg) {
        font-size: 20px;
      }
    }

    &-description {
      font-size: 24px;
      font-weight: 600;
      margin: 0.5em 0;
      white-space: pre-wrap;

      @include media-breakpoint-down(lg) {
        font-size: 16px;
      }
    }

    &.break {
      .session-content {
        margin-left: 0;
      }

      .session-title {
        border-radius: 10px;
        background: #82ccff;
        color: white;
        font-size: 24px;
        padding: 14px 50px;

        @include media-breakpoint-down(lg) {
          font-size: 20px;
          padding: 0.7em 10px;
        }
      }
    }
  }

  .speaker {
    font-size: 25px;
    font-weight: 400;
    margin-top: 15px;
    line-height: 1.2em;

    @include media-breakpoint-down(lg) {
      font-size: 16px;
    }

    &-qualifications {
      color: #7f7f7f;
      text-transform: uppercase;
      white-space: pre-wrap;
    }
  }
}
</style>
